__webpack_require__.p = "/mass-draft-calc/";